









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ModuleIframe extends Vue {

    @Prop() licenseType!: string
    @Prop() src!: string
    get showIframe(): boolean {
        if (this.$currentCompany.licenseType === this.licenseType) {
            return true
        }
    }
}
